import { ConfigProvider } from 'antd'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import ErrorPage from './pages/ErrorPage'
import App from './pages/App'
import './index.scss'

const route = createBrowserRouter([
    { path: '/', element: <App />, errorElement: <ErrorPage /> },
    { path: '/:formId', element: <App />, errorElement: <ErrorPage /> }
])

ReactDOM.createRoot(document.getElementById('root')!).render(
    <ConfigProvider
        theme={{
            components: {
                Button: {
                    colorPrimary: '#F18532',
                    algorithm: true
                }
            }
        }}
    >
        <RouterProvider router={route} />
    </ConfigProvider>
)
